/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Pausereason1Inputs */

const en_entity_pausereason1 = /** @type {(inputs: Entity_Pausereason1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pause Reason`)
};

const de_entity_pausereason1 = /** @type {(inputs: Entity_Pausereason1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausengrund`)
};

/**
* | output |
* | --- |
* | "Pause Reason" |
*
* @param {Entity_Pausereason1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_pausereason1 = /** @type {((inputs?: Entity_Pausereason1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Pausereason1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_pausereason1(inputs)
	return de_entity_pausereason1(inputs)
});
export { entity_pausereason1 as "entity_pauseReason" }